import { ThemeProvider } from '@emotion/react';
import './App.css';
import AppRouter from './routes/AppRouter';
import theme from './utils/theme';
import { Provider } from 'react-redux';
import { store } from './store';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { ToastContainer } from 'react-toastify';

function App() {
  return (
    <Provider store={store}>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <ThemeProvider theme={theme}>
          <AppRouter/>
          <ToastContainer/>
        </ThemeProvider>
      </LocalizationProvider>
    </Provider>
  );
}

export default App;
